import React, { useEffect, useState } from 'react'
import { Button, LayerBottom } from 'components'
import useApp from 'hooks/useApp'
import styles from './index.module.css'
import DetailTip from 'views/mydata/common/DetailTip'

const CarAccident = () => {

	const App = useApp()
	const [tabList, setTabList] = useState(0)
	const [detailTip, setDetailTip] = useState(false)
	const [usageTip, setUsageTip] = useState(false)
	const [specialTip, setSpecialTip] = useState(false)

	const openDetail = () => {
		setDetailTip(true)
	}

	const closeDetail = () => {
		setDetailTip(false)
	}

	const openUsage = () => {
		setUsageTip(true)
	}

	const closeUsage = () => {
		setUsageTip(false)
	}

	const openSpecial = () => {
		setSpecialTip(true)
	}

	const closeSpecial = () => {
		setSpecialTip(false)
	}


	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			{/* 사고이력 */}
			<div className="shadow">
				<div className="padding">
					<div className="flex-justify_between align_center">
						<h3>사고이력</h3>
						<span className={`${styles["title-guide"]} flex-align_center`}>2021.01.01 기준<i className="icon icon_update ml_5" /></span>
					</div>
					<span className={`${styles["title-guide"]} mt_10`}>* 무료조회 횟수 : 2회 </span>
				</div>
				<ul className="tab-scroll no-scroll mt_10">
					<li onClick={() => setTabList(0)} className={tabList === 0 ? "active" : ""}>보험사고이력</li>
					<li onClick={() => setTabList(1)} className={tabList === 1 ? "active" : ""}>특수사고</li>
					<li onClick={() => setTabList(2)} className={tabList === 2 ? "active" : ""}>특수용도</li>
					<li onClick={() => setTabList(3)} className={tabList === 3 ? "active" : ""}>번호변경</li>
					<li onClick={() => setTabList(4)} className={tabList === 4 ? "active" : ""}>소유자변경</li>
				</ul>
				<div className="padding" style={{ fontSize: "1.6rem" }}>보험 사고이력 상세<i className="icon icon_question ml_5" onClick={openDetail} /></div>
				<ul className="step-area list-bg pb_50">
					<li>
						<div>
							<span className="date">2015.04.20</span>
							<div className="txt-area flex-justify_between align_center">
								<p>내 차 사고 발생(피해)</p>
								<span>내 차 보험(처리)</span>
							</div>
							<div className="txt-area flex-justify_between align_center mt_10">
								<span style={{ color: "#333" }}>전손</span>
								<span className="text-blue" style={{ fontWeight: 500 }}>보험금 41,250,202 원</span>
							</div>
							<span className="circle" />
						</div>
					</li>
					<li>
						<div>
							<span className="date">2015.04.20</span>
							<div className="txt-area flex-justify_between align_center">
								<p>내 차 사고 발생(피해)</p>
								<span>내 차 보험(처리)</span>
							</div>
							<div className="txt-area flex-justify_between align_center mt_10">
								<span style={{ color: "#333" }}>전손</span>
								<span className="text-blue" style={{ fontWeight: 500 }}>보험금 41,250,202 원</span>
							</div>
							<span className="circle" />
						</div>
					</li>
				</ul>
			</div>

			{/* 특수사고 */}
			<div className="shadow">
				<div className="padding">
					<h3 className="flex-align_center">특수사고 <i className="icon icon_question ml_10" onClick={openSpecial} /></h3>
					<ul className="my-info-box mt_30">
						<li>
							<span>미납</span>
							<span>2015.05.20</span>
						</li>
						<li>
							<span>도난</span>
							<span>2015.05.20</span>
						</li>
						<li>
							<span>침수</span>
							<span>-</span>
						</li>
					</ul>
				</div>
			</div>

			{/* 특수용도 */}
			<div className="shadow">
				<div className="padding">
					<h3 className="flex-align_center">특수용도 <i className="icon icon_question ml_10" onClick={openUsage} /></h3>
					<ul className="list-item mt_30">
						<li>
							<span>대여용도(렌터카)</span>
							<span>-</span>
						</li>
						<li>
							<span>영업용도</span>
							<span>있음</span>
						</li>
						<li>
							<span>관용용도</span>
							<span>-</span>
						</li>
					</ul>
				</div>
			</div>

			{/* 번호변경 */}
			<div className="shadow">
				<div className="padding">
					<div className="flex-justify_between align_center">
						<h3>번호변경</h3>
						<strong className="text-blue" style={{ fontSize: "1.8rem" }}>1건</strong>
					</div>
					<ul className="list-item mt_30">
						<li>
							<span>2011.09.20</span>
							<span>변경</span>
						</li>
					</ul>
				</div>
			</div>

			{/* 소유자변경 */}
			<div>
				<div className="padding">
					<div className="flex-justify_between align_center">
						<h3>소유자변경</h3>
						<strong className="text-blue" style={{ fontSize: "1.8rem" }}>1건</strong>
					</div>
					<ul className="list-item mt_30">
						<li>
							<span>2011.09.20</span>
							<span>변경</span>
						</li>
					</ul>
				</div>
			</div>

			<DetailTip show={detailTip} closeLayer={closeDetail} title="보험사고이력" content={
				<>
					- 쌍방과실로 해당 자동차의 손상, 수리 기록이 내차 보험과 상대 보험에서 동시에 처리된 경우에는 '내차 보험’ 에만 표시되고 '상대 보험'에서는 생략돼요.- 수리(견적)비용
					자동차사고로 자동차가 손상된 경우 보험회사가 지급하는 보험금 중에서 자동차 운반비, 대차료(렌트비용), 휴차료 등의 간접손해와 과실상계액 등을 제외한, 자동차를 수리하는데 소요되는 비용 또는 견적으로 부품비용, 공임 및 도장료로 이루어져요.<br />
					<span className="mt_10">- 미확정 사고</span><br />
					자동차보험사고로 보험회사에 접수된 후 사고처리가 끝나지 않아 지급할 보험금액이 아직 확정되지 않았거나 확정되었는데 아직 보험개발원에 관련 자료가 넘어오지 않아(월 1회 전송, 2~3개월 소요) 확정처리 되지 않은 사고를 말해요.<br />
					<span className="mt_10">- 미가입 기간</span><br />
					자기차량손해담보 미가입기간으로 해당기간에 대해서는 자기차량손해담보에 의해 지급된 자동차수리비 정보를 제공할 수 없는 기간을 말해요.<br />
					- 내 차 보험처리 사고 : 내 보험으로 처리한 내 차 사고를 말해요. (대인사고 제외)<br />
					- 상대 보험처리 사고 : 다른 차량 보험으로 처리한 내 차 사고를 말해요. (대인사고 제외)<br />
					- 상대 차 피해 사고 : 내 보험으로 처리한 상대 차 사고를 말해요. (대인사고 제외)
				</>
			} />
			<UsageTip show={usageTip} closeLayer={closeUsage} />
			<SpecialTip show={specialTip} closeLayer={closeSpecial} />
		</div>
	)
}

const UsageTip = ({ show, closeLayer }) => {
	return (
		<LayerBottom title="특수용도" show={show} closeButton={false} closeLayer={closeLayer} outside={
			<Button className="btn btn--big btn-layer" onClick={() => closeLayer()}>확인</Button>
		}>
			<div className="layer-text">
				- 과거 해당 차량에 사용되었던 자동차등록번호를 자동차등록번호판의 용도별 분류기호에 관한 기준에 따라 분류, 제공하는 것으로 대여용(렌트카), 영업용(택시 등)으로 사용된 적이 있는지 확인해요.
			</div>
		</LayerBottom>
	)
}

const SpecialTip = ({ show, closeLayer }) => {
	return (
		<LayerBottom title="특수사고" show={show} closeButton={false} closeLayer={closeLayer} outside={
			<Button className="btn btn--big btn-layer" onClick={() => closeLayer()}>확인</Button>
		}>
			<div className="layer-text">
				- 전손 보험사고<br />
				손상된 자동차의 수리비용이 자동차가치(보험회사에서 적정하다고 인정한)를 초과한 경우(추정전손) 및 손상된 자동차의 수리가 불가능하거나 수리를 하더라도 자동차로서의 기능을 다할 수 없는 경우(절대전손)로 자동차보험에서 보상처리 받은 사고를 말해요.<br />
				<span className="mt_10">- 도난 보험사고</span><br />
				자동차를 도난 당하여 경찰서에 신고한지 30일이 지나도록 도난 당한 자동차를 찾지 못하여 자동차 보험에서 보상처리 받은 사고를 말해요.<br />
				<span className="mt_10">- 침수 보험사고</span><br />
				자동차를 운행하던 중 자동차 내부로 물이 들어와 시동이 꺼지거나, 주차 중 엔진 등에 물이 들어가 운행이 불가능하게 되어 자동차에 손해가 발생한 사고를 말해요.
				침수 보험사고는 침수 전(분)손 사고를 의미하며, 전손 보험사고는 침수 보험사고와 도난 보험사고를 제외한 일반(기타) 전손사고를 의미해요.
			</div>
		</LayerBottom>
	)
}



export default CarAccident